const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  variantChange: "variant-change",
  cartError: "cart-error",
  cartItemRemove: "cart-item-remove",
  quantityUpdate: "quantity-update",
};

// Top-level const is not a window property; expose for inline / deferred scripts that check window.
window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
